export default [
    {
        path: "/a",
        name: "user-list",
        meta: { title: "User List" },
        component: () => import("../views/live-preview/application/users/user-list.vue"),
    },
    {
        path: "/landing",
        name: "landing",
        meta: { title: "Landing Preview" },
        component: () => import("../views/live-preview/pages/landing.vue"),
    },
    {
        path: "/layout/horizontal",
        name: "Horizontal Layout",
        meta: { title: "Horizontal Layout" },
        component: () => import("../layout/horizontal.vue"),
    },
    {
        path: "/layout/layout-2",
        name: "layout-2 Layout",
        meta: { title: "Layout-2 Layout" },
        component: () => import("../layout/layout-2.vue"),
    },
    {
        path: "/layout/layout-moduler",
        name: "Moduler Layout",
        meta: { title: "Moduler Layout" },
        component: () => import("../layout/layout-moduler.vue"),
    },
    {
        path: "/layout/layout-2-column",
        name: "Layout 2 Column",
        meta: { title: "Layout 2 Column" },
        component: () => import("../layout/layout-2-column.vue"),
    },
    // {
    //     path: "/dashboard",
    //     name: "dashboard",
    //     meta: { title: "Home" },
    //     component: () => import("../views/live-preview/dashboard.vue"),
    // },

    {
        path: "/sample-page",
        name: "sample-page",
        meta: { title: "sampl Page" },
        component: () => import("../views/live-preview/other/sample-page.vue"),
    },
    {
        path: "/setting",
        name: "setting",
        meta: { title: "Setting" },
        component: () => import("../views/live-preview/ui-kit/setting.vue"),
    },
    {
        path: "/application/plans",
        name: "Apps Plans",
        meta: { title: "Apps Plans" },
        component: () => import("../views/live-preview/ui-kit/plans.vue"),
    },
    {
        path: "/admins/course-course-add",
        name: "course-course-add",
        meta: { title: "Courses Add" },
        component: () => import("../views/live-preview/admins/course-course-add.vue"),
    },
    {
        path: "/admins/course-course-view",
        name: "course-course-view",
        meta: { title: "Courses View" },
        component: () => import("../views/live-preview/admins/course-course-view.vue"),
    },
    {
        path: "/admins/course-dashboard",
        name: "course-dashboard",
        meta: { title: "Online Courses" },
        component: () => import("../views/live-preview/admins/course-dashboard.vue"),
    },
    {
        path: "/admins/course-pricing",
        name: "course-Pricing",
        meta: { title: "Courses Pricing" },
        component: () => import("../views/live-preview/admins/course-pricing.vue"),
    },
    {
        path: "/admins/course-setting-notifications",
        name: "course-setting-notifications",
        meta: { title: "Courses Setting Notifications" },
        component: () => import("../views/live-preview/admins/course-setting-notifications.vue"),
    },
    {
        path: "/admins/course-setting-payment",
        name: "course-setting-payment",
        meta: { title: "Courses Setting payment" },
        component: () => import("../views/live-preview/admins/course-setting-payment.vue"),
    },
    {
        path: "/admins/course-setting-pricing",
        name: "course-setting-pricing",
        meta: { title: "Courses Setting Pricing" },
        component: () => import("../views/live-preview/admins/course-setting-pricing.vue"),
    },
    {
        path: "/admins/course-site",
        name: "course-site",
        meta: { title: "Site" },
        component: () => import("../views/live-preview/admins/course-site.vue"),
    },
    {
        path: "/admins/course-student-add",
        name: "course-student-add",
        meta: { title: "Student Add" },
        component: () => import("../views/live-preview/admins/course-student-add.vue"),
    },
    {
        path: "/admins/course-student-apply",
        name: "course-student-apply",
        meta: { title: "Student Apply" },
        component: () => import("../views/live-preview/admins/course-student-apply.vue"),
    },
    {
        path: "/admins/course-student-list",
        name: "course-student-list",
        meta: { title: "Student List" },
        component: () => import("../views/live-preview/admins/course-student-list.vue"),
    },
    {
        path: "/admins/course-teacher-add",
        name: "course-teacher-add",
        meta: { title: "Teacher Add" },
        component: () => import("../views/live-preview/admins/course-teacher-add.vue"),
    },
    {
        path: "/admins/course-teacher-apply",
        name: "course-teacher-apply",
        meta: { title: "Teacher apply" },
        component: () => import("../views/live-preview/admins/course-teacher-apply.vue"),
    },
    {
        path: "/admins/course-teacher-list",
        name: "course-teacher-list",
        meta: { title: "Teacher List" },
        component: () => import("../views/live-preview/admins/course-teacher-list.vue"),
    },
    {
        path: "/admins/helpdesk-create-ticket",
        name: "helpdask Create Ticket",
        meta: { title: "Create Ticket" },
        component: () => import("../views/live-preview/admins/helpdesk-create-ticket.vue"),
    },
    // {
    //     path: "/admins/helpdesk-dashboard",
    //     name: "helpdesk",
    //     meta: { title: "Create Dashboard" },
    //     component: () => import("../views/live-preview/admins/helpdesk-dashboard.vue"),
    // },
    {
        path: "/admins/helpdesk-ticket-details",
        name: "Ticket Details",
        meta: { title: "Ticket Details" },
        component: () => import("../views/live-preview/admins/helpdesk-ticket-details.vue"),
    },
    {
        path: "/admins/helpdesk-customer",
        name: "Customers",
        meta: { title: "Customers" },
        component: () => import("../views/live-preview/admins/helpdesk-customer.vue"),
    },
    {
        path: "/admins/helpdesk-ticket",
        name: "Customers-ticket",
        meta: { title: "Ticket" },
        component: () => import("../views/live-preview/admins/helpdesk-ticket.vue"),
    },
    {
        path: "/admins/invoice-edit",
        name: "Invoice Edit",
        meta: { title: "Invoice Edit" },
        component: () => import("../views/live-preview/admins/invoice-edit.vue"),
    },
    {
        path: "/admins/invoice-list",
        name: "Invoice List",
        meta: { title: "Invoice List" },
        component: () => import("../views/live-preview/admins/invoice-list.vue"),
    },
    {
        path: "/admins/invoice-create",
        name: "Invoice Create",
        meta: { title: "Invoice Create" },
        component: () => import("../views/live-preview/admins/invoice-create.vue"),
    },
    {
        path: "/admins/invoice-dashboard",
        name: "Invoice Dashboard",
        meta: { title: "Invoice Dashboard" },
        component: () => import("../views/live-preview/admins/invoice-dashboard.vue"),
    },
    {
        path: "/admins/invoice-view",
        name: "Invoice View",
        meta: { title: "Invoice View" },
        component: () => import("../views/live-preview/admins/invoice-view.vue"),
    },
    {
        path: "/admins/membership-dashboard",
        name: "Membership Dashboard",
        meta: { title: "Membership Dashboard" },
        component: () => import("../views/live-preview/admins/membership-dashboard.vue"),
    },
    {
        path: "/admins/membership-list",
        name: "Membership List",
        meta: { title: "Membership List" },
        component: () => import("../views/live-preview/admins/membership-list.vue"),
    },
    {
        path: "/admins/membership-pricing",
        name: "Membership Pricing",
        meta: { title: "Membership Pricing" },
        component: () => import("../views/live-preview/admins/membership-pricing.vue"),
    },
    {
        path: "/admins/membership-setting",
        name: "Membership Setting",
        meta: { title: "Membership Setting" },
        component: () => import("../views/live-preview/admins/membership-setting.vue"),
    },
    {
        path: "/login-modal",
        name: "login modal",
        meta: { title: "Login Modal" },
        component: () => import("../views/live-preview/ui-kit/login-modal.vue"),
    },
    {
        path: "/search-page",
        name: "search page",
        meta: { title: "Search Page" },
        component: () => import("../views/live-preview/ui-kit/search-page.vue"),
    },
    {
        path: "/affiliate-dashboard",
        name: "affiliate dashboard",
        meta: { title: "Affiliate Dashboard" },
        component: () => import("../views/live-preview/dashboard/affiliate-dashboard.vue"),
    },
    {
        path: "/finance",
        name: "finance",
        meta: { title: "Finance Dashboard" },
        component: () => import("../views/live-preview/dashboard/finance.vue"),
    },
    {
        path: "/invoice",
        name: "Invoice",
        meta: { title: "Invoice Dashboard" },
        component: () => import("../views/live-preview/dashboard/invoice.vue"),
    },
    // {
    //     path: "/helpdesk-dashboard",
    //     name: "helpdesk-dashboard",
    //     meta: { title: "Helpdesk" },
    //     component: () => import("../views/live-preview/dashboard/helpdesk.vue"),
    // },
    {
        path: "/gallery-1",
        name: "gallery-1",
        meta: { title: "Gallery" },
        component: () => import("../views/live-preview/ui-kit/gallery.vue"),
    },
    {
        path: "/team",
        name: "team",
        meta: { title: "Team" },
        component: () => import("../views/live-preview/ui-kit/team.vue"),
    },
    {
        path: "/loading",
        name: "loading",
        meta: { title: "Loading" },
        component: () => import("../views/live-preview/ui-kit/loading.vue"),
    },
    {
        path: "/contact-search",
        name: "contact-search",
        meta: { title: "Contact Search" },
        component: () => import("../views/live-preview/ui-kit/contact-search.vue"),
    },
    {
        path: "/contact-us",
        name: "contact-us",
        meta: { title: "Contact Us" },
        component: () => import("../views/live-preview/ui-kit/contact-us.vue"),
    },

    // Widget
    {
        path: "/statistics",
        name: "statistics",
        meta: { title: "Statistics Widget" },
        component: () => import("../views/live-preview/widget/statistics.vue"),
    },
    {
        path: "/user",
        name: "user",
        meta: { title: "User Widget" },
        component: () => import("../views/live-preview/widget/user.vue"),
    },
    {
        path: "/data",
        name: "data",
        meta: { title: "Data Widget" },
        component: () => import("../views/live-preview/widget/data.vue"),
    },
    {
        path: "/chart",
        name: "chart",
        meta: { title: "Chart Widget" },
        component: () => import("../views/live-preview/widget/chart.vue"),
    },
    {
        path: "/animation",
        name: "animation",
        meta: { title: "Animation" },
        component: () => import("../views/live-preview/elements/animation.vue"),
    },
    // Components
    {
        path: "/feather",
        name: "feather",
        meta: { title: "Feather icon" },
        component: () => import("../views/live-preview/icon/feather.vue"),
    },
    {
        path: "/tabler",
        name: "tabler",
        meta: { title: "Tabler icon" },
        component: () => import("../views/live-preview/icon/tabler.vue"),
    },
    {
        path: "/phosphor",
        name: "phosphor",
        meta: { title: "Phosphor" },
        component: () => import("../views/live-preview/icon/phosphor.vue"),
    },

    // Forms
    {
        path: "/form-element",
        name: "form-element",
        meta: { title: "Form Element" },
        component: () => import("../views/live-preview/form/element/basic.vue"),
    },
    {
        path: "/floating",
        name: "floating",
        meta: { title: "Floating" },
        component: () => import("../views/live-preview/form/element/floating.vue"),
    },
    {
        path: "/form-option",
        name: "form-option",
        meta: { title: "Form Option" },
        component: () => import("../views/live-preview/form/element/options.vue"),
    },
    {
        path: "/input-group",
        name: "input-group",
        meta: { title: "Input Group" },
        component: () => import("../views/live-preview/form/element/input-group.vue"),
    },
    {
        path: "/checkbox",
        name: "checkbox",
        meta: { title: "Checkbox" },
        component: () => import("../views/live-preview/form/element/checkbox.vue"),
    },
    {
        path: "/radio",
        name: "radio",
        meta: { title: "Radio" },
        component: () => import("../views/live-preview/form/element/radio.vue"),
    },
    {
        path: "/switch",
        name: "switch",
        meta: { title: "Switch" },
        component: () => import("../views/live-preview/form/element/switch.vue"),
    },
    {
        path: "/mega-option",
        name: "mega-option",
        meta: { title: "Mega Option" },
        component: () => import("../views/live-preview/form/element/mega-option.vue"),
    },
    {
        path: "/layouts",
        name: "layouts",
        meta: { title: "Layouts" },
        component: () => import("../views/live-preview/form/layout/layout.vue"),
    },
    {
        path: "/multicolumn",
        name: "multicolumn",
        meta: { title: "Multicolumn" },
        component: () => import("../views/live-preview/form/layout/multicolumn.vue"),
    },
    {
        path: "/actionbars",
        name: "actionbars",
        meta: { title: "Actionbars" },
        component: () => import("../views/live-preview/form/layout/actionbars.vue"),
    },
    {
        path: "/sticky-action",
        name: "sticky-action",
        meta: { title: "Sticky Action" },
        component: () => import("../views/live-preview/form/layout/sticky-action.vue"),
    },
    {
        path: "/dropzone",
        name: "dropzone",
        meta: { title: "Dropzone" },
        component: () => import("../views/live-preview/form/upload/dropzone.vue"),
    },
    {
        path: "/form2_wizard",
        name: "Wizard",
        meta: { title: "Wizard" },
        component: () => import("../views/live-preview/form/wizard/wizard.vue"),
    },

    {
        path: "/validation",
        name: "validation",
        meta: { title: "Form Validation" },
        component: () => import("../views/live-preview/form/validation.vue"),
    },
    {
        path: "/image-croper",
        name: "image-croper",
        meta: { title: "Image Cropper" },
        component: () => import("../views/live-preview/form/image-croper.vue"),
    },

    // Tables
    {
        path: "/basic-table",
        name: "basic-table",
        meta: { title: "Basic Table" },
        component: () => import("../views/live-preview/table/bootstrap/basic.vue"),
    },
    {
        path: "/sizing-table",
        name: "sizing-table",
        meta: { title: "Sizing Table" },
        component: () => import("../views/live-preview/table/bootstrap/sizing.vue"),
    },
    {
        path: "/border-table",
        name: "border-table",
        meta: { title: "Border Table" },
        component: () => import("../views/live-preview/table/bootstrap/border.vue"),
    },
    {
        path: "/styling-table",
        name: "styling-table",
        meta: { title: "Styling Table" },
        component: () => import("../views/live-preview/table/bootstrap/styling.vue"),
    },
    {
        path: "/basic",
        name: "basic",
        meta: { title: "Basic Initialization" },
        component: () => import("../views/live-preview/table/vanila/basic.vue"),
    },
    {
        path: "/dynamic-import",
        name: "dynamic import",
        meta: { title: "Dynamic Import" },
        component: () => import("../views/live-preview/table/vanila/dynamic.vue"),
    },
    {
        path: "/column-cells",
        name: "column cells",
        meta: { title: "Column Cells" },
        component: () => import("../views/live-preview/table/vanila/column.vue"),
    },
    {
        path: "/datetime-sorting",
        name: "datetime sorting",
        meta: { title: "Datetime Sorting" },
        component: () => import("../views/live-preview/table/vanila/datetime.vue"),
    },
    {
        path: "/method",
        name: "method",
        meta: { title: "Method" },
        component: () => import("../views/live-preview/table/vanila/method.vue"),
    },
    {
        path: "/row",
        name: "row",
        meta: { title: "Add Row" },
        component: () => import("../views/live-preview/table/vanila/row.vue"),
    },
    {
        path: "/api",
        name: "api",
        meta: { title: "Fetch APi" },
        component: () => import("../views/live-preview/table/vanila/api.vue"),
    },
    {
        path: "/filter",
        name: "filter",
        meta: { title: "Filter" },
        component: () => import("../views/live-preview/table/vanila/filter.vue"),
    },
    {
        path: "/export",
        name: "export",
        meta: { title: "Export" },
        component: () => import("../views/live-preview/table/vanila/export.vue"),
    },

    // Charts & maps
    {
        path: "/apexchart",
        name: "apexchart",
        meta: { title: "Apex Chart" },
        component: () => import("../views/live-preview/charts&map/apexchart/apexchart.vue"),
    },
    {
        path: "/maps",
        name: "maps",
        meta: { title: "Maps" },
        component: () => import("../views/live-preview/charts&map/map.vue"),
    },
    // {
    //     path: "/v-maps",
    //     name: "Vector Maps",
    //     meta: { title: "Vector Maps" },
    //     component: () => import("../views/live-preview/charts&map/v-map.vue"),
    // },

    // Apllication
    {
        path: "/calendar",
        name: "calendar",
        meta: { title: "Calendar" },
        component: () => import("../views/live-preview/application/calendar/index.vue"),
    },
    {
        path: "/chat",
        name: "chat",
        meta: { title: "Chat" },
        component: () => import("../views/live-preview/application/chat.vue"),
    },
    {
        path: "/assistant",
        name: "assistant",
        meta: { title: "Assistant" },
        component: () => import("../views/live-preview/application/assistant.vue"),
    },
    {
        path: "/send-notification",
        name: "send-notification",
        meta: { title: "Send Notification" },
        component: () => import("../views/live-preview/application/send-notification.vue"),
    },
    {
        path: "/ask-us-logs",
        name: "ask-us-logs",
        meta: { title: "Ask Us Logs" },
        component: () => import("../views/live-preview/application/bot-logs.vue"),
    },
    {
        path: "/commissions-setup",
        name: "commissions-setup",
        meta: { title: "Setup Commissions" },
        component: () => import("../views/live-preview/application/commissions-setup.vue"),
    },
    {
        path: "/commissions-info",
        name: "commissions-info",
        meta: { title: "Commissions Information" },
        component: () => import("../views/live-preview/application/commissions-info.vue"),
    },
    {
        path: "/permissions-setup",
        name: "permissions-setup",
        meta: { title: "Setup Groups and Permissions" },
        component: () => import("../views/live-preview/application/permissions-setup.vue"),
    },
    {
        path: "/categories-setup",
        name: "categories-setup",
        meta: { title: "Setup Categories" },
        component: () => import("../views/live-preview/application/categories-setup.vue"),
    },
    {
        path: "/calendar-setup",
        name: "calendar-setup",
        meta: { title: "Setup Calendar" },
        component: () => import("../views/live-preview/application/calendar-setup.vue"),
    },
    {
        path: "/quotes-setup",
        name: "quotes-setup",
        meta: { title: "Setup Quotes" },
        component: () => import("../views/live-preview/application/quotes-setup.vue"),
    },
    {
        path: "/prompts-setup",
        name: "prompts-setup",
        meta: { title: "Setup Prompts" },
        component: () => import("../views/live-preview/application/prompts-setup.vue"),
    },
    {
        path: "/resources-setup",
        name: "resources-setup",
        meta: { title: "Setup Resources" },
        component: () => import("../views/live-preview/application/resources-setup.vue"),
    },
    {
        path: "/broker-setup",
        name: "broker-setup",
        meta: { title: "Setup Broker" },
        component: () => import("../views/live-preview/application/broker-setup.vue"),
    },
    {
        path: "/gallery-grid",
        name: "gallery-grid",
        meta: { title: "Gallery" },
        component: () => import("../views/live-preview/application/gallery-grid.vue"),
    },
    {
        path: "/gallery-masonry",
        name: "gallery-masonry",
        meta: { title: "Gallery" },
        component: () => import("../views/live-preview/application/gallery-masonry.vue"),
    },

    // E-commerce
    {
        path: "/product",
        name: "Products",
        meta: { title: "Product" },
        component: () => import("../views/live-preview/application/e-commerce/product.vue"),
    },
    {
        path: "/add-product",
        name: "add-product",
        meta: { title: "Add New Product" },
        component: () => import("../views/live-preview/application/e-commerce/add-product.vue"),
    },
    {
        path: "/product-details",
        name: "Product Details",
        meta: { title: "product Details" },
        component: () => import("../views/live-preview/application/e-commerce/product-details.vue"),
    },
    {
        path: "/product-list",
        name: "Product List",
        meta: { title: "Product List" },
        component: () => import("../views/live-preview/application/e-commerce/product-list.vue"),
    },
    {
        path: "/checkout",
        name: "checkout",
        meta: { title: "Checkout" },
        component: () => import("../views/live-preview/application/e-commerce/checkout.vue"),
    },
    {
        path: "/mail",
        name: "mail",
        meta: { title: "Mail" },
        component: () => import("../views/live-preview/application/mail.vue"),
    },
    {
        path: "/plans",
        name: "plans",
        meta: { title: "plans" },
        component: () => import("../views/live-preview/application/plans.vue"),
    },

    // Users
    {
        path: "/account-profile",
        name: "account-profile",
        meta: { title: "Account Profile" },
        component: () => import("../views/live-preview/application/users/account-profile.vue"),
    },
    {
        path: "/social-media",
        name: "social-media",
        meta: { title: "Social Media" },
        component: () => import("../views/live-preview/application/users/social-media.vue"),
    },
    {
        path: "/user-card",
        name: "user-card",
        meta: { title: "User Card" },
        component: () => import("../views/live-preview/application/users/user-card.vue"),
    },
    {
        path: "/user-list",
        name: "user-list",
        meta: { title: "User List" },
        component: () => import("../views/live-preview/application/users/user-list.vue"),
    },
    {
        path: '/edit-profile',
        name: "edit-profile",
        meta: { title: "Profile Edit" },
        component: () => import("../views/live-preview/application/users/edit-profile.vue"),
    },
    {
        path: '/user-edit/:userId',
        name: "user-edit",
        meta: { title: "User Edit" },
        component: () => import("../views/live-preview/application/users/user-edit.vue"),
    },
    {
        path: '/user-add',
        name: "user-add",
        meta: { title: "User Add" },
        component: () => import("../views/live-preview/application/users/user-add.vue"),
    },

    // Invoice
    {
        path: "/invoice-list",
        name: "invoice-list",
        meta: { title: "Invoice List" },
        component: () => import("../views/live-preview/application/invoice/invoice-list.vue"),
    },
    {
        path: "/create",
        name: "create",
        meta: { title: "Create" },
        component: () => import("../views/live-preview/application/invoice/create.vue"),
    },
    {
        path: "/preview",
        name: "preview",
        meta: { title: "Preview" },
        component: () => import("../views/live-preview/application/invoice/preview.vue"),
    },

    // Auth 1
    {
        path: "/login",
        name: "login",
        meta: { title: "Login" },
        component: () => import("../views/live-preview/pages/auth1/login.vue"),
    },
    {
        path: "/register-v1",
        name: "register-v1",
        meta: { title: "Register" },
        component: () => import("../views/live-preview/pages/auth1/register.vue"),
    },
    {
        path: "/forgot-password-v1",
        name: "forgot-password-v1",
        meta: { title: "Forgot Password" },
        component: () => import("../views/live-preview/pages/auth1/forgot-password.vue"),
    },
    {
        path: "/reset-password-v1",
        name: "reset-password-v1",
        meta: { title: "Reset Password" },
        component: () => import("../views/live-preview/pages/auth1/reset-password.vue"),
    },
    {
        path: "/code-verification-v1",
        name: "code-verification-v1",
        meta: { title: "code-verification" },
        component: () => import("../views/live-preview/pages/auth1/code-verification.vue"),
    },

    // Auth 2
    {
        path: "/login-v2",
        name: "login-v2",
        meta: { title: "Login" },
        component: () => import("../views/live-preview/pages/auth2/login.vue"),
    },
    {
        path: "/register-v2",
        name: "register-v2",
        meta: { title: "Register" },
        component: () => import("../views/live-preview/pages/auth2/register.vue"),
    },
    {
        path: "/forgot-password-v2",
        name: "forgot-password-v2",
        meta: { title: "Forgot Password" },
        component: () => import("../views/live-preview/pages/auth2/forgot-password.vue"),
    },
    {
        path: "/reset-password-v2",
        name: "reset-password-v2",
        meta: { title: "Reset Password" },
        component: () => import("../views/live-preview/pages/auth2/reset-password.vue"),
    },
    {
        path: "/code-verification-v2",
        name: "code-verification-v2",
        meta: { title: "code-verification" },
        component: () => import("../views/live-preview/pages/auth2/code-verification.vue"),
    },

    // maintanance
    {
        path: "/error-404",
        name: "error-404",
        meta: { title: "404" },
        component: () => import("../views/live-preview/pages/maintenance/error-404.vue"),
    },
    {
        path: "/connection-lost",
        name: "connection-lost",
        meta: { title: "Connection Lost" },
        component: () => import("../views/live-preview/pages/maintenance/connection-lost.vue"),
    },
    {
        path: "/under-construction",
        name: "under-construction",
        meta: { title: "Under Construction" },
        component: () => import("../views/live-preview/pages/maintenance/under-construction.vue"),
    },
    {
        path: "/comming-soon",
        name: "comming-soon",
        meta: { title: "Comming Soon" },
        component: () => import("../views/live-preview/pages/maintenance/comming-soon.vue"),
    },

    // Components
    {
        path: "/components/",
        name: "alert",
        meta: { title: "Alert" },
        component: () => import("../views/components/basic/alert.vue"),
    },
    {
        path: "/components/alert",
        name: "alerts",
        meta: { title: "Alerts" },
        component: () => import("../views/components/basic/alert.vue"),
    },
    {
        path: "/components/button",
        name: "button",
        meta: { title: "Button" },
        component: () => import("../views/components/basic/button.vue"),
    },
    {
        path: "/components/badges",
        name: "badges",
        meta: { title: "Badges" },
        component: () => import("../views/components/basic/badges.vue"),
    },
    {
        path: "/components/breadcrumb",
        name: "breadcrumb",
        meta: { title: "Breadcrumb" },
        component: () => import("../views/components/basic/breadcrumb.vue"),
    },
    {
        path: "/components/cards",
        name: "cards",
        meta: { title: "Cards" },
        component: () => import("../views/components/basic/cards.vue"),
    },
    {
        path: "/components/color",
        name: "color",
        meta: { title: "Color" },
        component: () => import("../views/components/basic/color.vue"),
    },
    {
        path: "/components/collapse",
        name: "collapse",
        meta: { title: "Collapse" },
        component: () => import("../views/components/basic/collapse.vue"),
    },
    {
        path: "/components/carousel",
        name: "carousel",
        meta: { title: "Carousel" },
        component: () => import("../views/components/basic/carousel.vue"),
    },
    {
        path: "/components/dropdown",
        name: "dropdown",
        meta: { title: "Dropdown" },
        component: () => import("../views/components/basic/dropdown.vue"),
    }, {
        path: "/components/offcanvas",
        name: "offcanvas",
        meta: { title: "Offcanvas" },
        component: () => import("../views/components/basic/offcanvas.vue"),
    },
    {
        path: "/components/pagination",
        name: "pagination",
        meta: { title: "Pagination" },
        component: () => import("../views/components/basic/pagination.vue"),
    },
    {
        path: "/components/progress",
        name: "progress",
        meta: { title: "Progress" },
        component: () => import("../views/components/basic/progress.vue"),
    },
    {
        path: "/components/list-group",
        name: "list-group",
        meta: { title: "List-group" },
        component: () => import("../views/components/basic/list-group.vue"),
    },
    {
        path: "/components/b-modal",
        name: "b-modal",
        meta: { title: "Modal" },
        component: () => import("../views/components/basic/modal.vue"),
    },
    {
        path: "/components/spinner",
        name: "spinner",
        meta: { title: "Spinner" },
        component: () => import("../views/components/basic/spinner.vue"),
    },
    {
        path: "/components/tabs-pills",
        name: "tabs&pills",
        meta: { title: "Tabs&pills" },
        component: () => import("../views/components/basic/tabs-pills.vue"),
    },
    {
        path: "/components/tooltip",
        name: "tooltip",
        meta: { title: "Tooltip" },
        component: () => import("../views/components/basic/tooltip.vue"),
    },
    {
        path: "/components/toasts",
        name: "toasts",
        meta: { title: "Toasts" },
        component: () => import("../views/components/basic/toasts.vue"),
    },
    {
        path: "/components/typograbhy",
        name: "typograbhy",
        meta: { title: "Typograbhy" },
        component: () => import("../views/components/basic/typograbhy.vue"),
    },
    {
        path: "/components/other",
        name: "other",
        meta: { title: "Other" },
        component: () => import("../views/components/basic/other.vue"),
    },

    // Advance Components
    {
        path: "/components/sweet-alert",
        name: "sweet-alert",
        meta: { title: "Sweet Alert" },
        component: () => import("../views/components/advance/sweet-alert.vue"),
    },
    {
        path: "/components/datepicker",
        name: "datepicker",
        meta: { title: "Datepicker" },
        component: () => import("../views/components/advance/datepicker.vue"),
    },
    {
        path: "/components/lightbox",
        name: "lightbox",
        meta: { title: "Lightbox" },
        component: () => import("../views/components/advance/lightbox.vue"),
    },
    {
        path: "/components/a-modal",
        name: "a-modal",
        meta: { title: "Modal" },
        component: () => import("../views/components/advance/modal.vue"),
    },
    {
        path: "/components/rangeslider",
        name: "rangeslider",
        meta: { title: "Rangeslider" },
        component: () => import("../views/components/advance/rangeslider.vue"),
    },
    {
        path: "/components/slider",
        name: "slider",
        meta: { title: "Slider" },
        component: () => import("../views/components/advance/slider.vue"),
    },
    {
        path: "/components/highlighter",
        name: "highlighter",
        meta: { title: "Highlighter" },
        component: () => import("../views/components/advance/highlighter.vue"),
    },
    {
        path: "/components/tour",
        name: "tour",
        meta: { title: "Tour" },
        component: () => import("../views/components/advance/tour.vue"),
    },
    {
        path: "/components/tree-view",
        name: "tree-view",
        meta: { title: "Tree view" },
        component: () => import("../views/components/advance/tree-view.vue"),
    },
]